import React, { useState, useRef, useEffect, useCallback } from "react";
import ClipLoader from "react-spinners/ClipLoader";
import DropdownProperties from "../common/DropdownProperties.jsx";
import { useLocation, useNavigate, Link } from "react-router-dom";
import { useGetAllProperties, GetAllNearbyAmenities } from "../../APIs/MasterAPIHelper.js";
import { useSnackbar } from "notistack";
import { PropertyNearAmenities,NewProperty } from "../../APIs/APIUrls.js";
import { handleKeyNumberwithDotPress } from "../../APIs/Helper.js";
import Pagination2 from "../common/Pagination2.jsx";
import "./AddNearAmenities.css";

import SidebarMenu from "../../components/dashboard/SidebarMenu";
import Header2 from "../../components/headers/Header2";
import MetaComponent from "../../components/common/MetaComponent";

const metadata = {
    title: "Add Property Near Amenities || AskMeRealty - Real Estate",
    description: "AskMeRealty - Real Estate",
};

export default function AddNearAmenities() {
    const { enqueueSnackbar } = useSnackbar();
    const fetchAllProperties = useGetAllProperties();
    const location = useLocation();
    const navigate = useNavigate();

    const vendorid = localStorage.getItem("id") || 0;

    let Token = null;
    try {
        const tokenStr = localStorage.getItem("tcn");
        Token = tokenStr ? JSON.parse(tokenStr) : null;
    } catch (error) {
        console.error("Error parsing token:", error);
        Token = localStorage.getItem("tcn");
    }

    const [page, setPage] = useState(1);
    const [ItemsPerPage] = useState(10);

    const [PropertyIdFilter, setPropertyIdFilter] = useState("");
    const PropertyFilterref = useRef();

    const [lstProperties, setLstProperties] = useState([]);
    const [lstPropertiesFilter, setLstPropertiesFilter] = useState([]);
    const [PropertyId, setPropertyId] = useState("");
    const Propertyref = useRef();

    const [lstAmenities, setLstAmenities] = useState([]);
    const [selectedAmenitiesData, setSelectedAmenitiesData] = useState([]);

    const [lstPropertyNearAmenities, setLstPropertyNearAmenities] = useState([]);
    const [lstPropertyNearAmenitiesFilter, setLstPropertyNearAmenitiesFilter] = useState([]);

    const [isLoading, setIsLoading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [queryPropertyId, setQueryPropertyId] = useState("");

    const buildPropertyOptions = useCallback((propertiesInput) => {
        const mapped = (Array.isArray(propertiesInput) ? propertiesInput : [])
            .filter((prop) => prop && prop.PropertyId != null)
            .map((prop) => ({
                PropertyGeneratedId: `${prop.PropertyGeneratedId || ""}: ${prop.PropertyTitle || ""}`.trim(),
                PropertyId: String(prop.PropertyId),
            }));

        const uniqueOptions = Array.from(
            new Map(mapped.map((item) => [String(item.PropertyId), item])).values()
        );
        uniqueOptions.unshift({ PropertyGeneratedId: "Select", PropertyId: "0" });
        return uniqueOptions;
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const propertyIdFromQuery = params.get("id");

        const validateQueryString = async (propertyId) => {
            if (!propertyId || propertyId === "0") {
                return;
            }
debugger
            const isNumericId = /^\d+$/.test(String(propertyId));
            if (!isNumericId) {
                enqueueSnackbar("Invalid property ID in the URL.", { variant: "error" });
                localStorage.clear();
                window.location.href = "/"; // Use full page reload to ensure all state is cleared
                return;
            }

            try {
                const tokenStr = JSON.parse(localStorage.getItem('tcn'));
                const vid = localStorage.getItem("id") || 0;

                const res = await fetch(`${NewProperty}GetNewPropertyByVendorId/${vid}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${tokenStr}`
                    }
                });

                if (!res.ok) {
                    throw new Error(`Request failed with status ${res.status}`);
                }

                const result = await res.json();
                const vendorProperties = Array.isArray(result?.data)
                    ? result.data
                    : result?.data
                        ? [result.data]
                        : Array.isArray(result)
                            ? result
                            : [];

                const isAllowed = vendorProperties.some((item) => String(item?.PropertyId) === String(propertyId));

                if (!isAllowed) {
                    enqueueSnackbar(
                        "Unauthorized or invalid property ID in the query string. Please check the URL.",
                        { variant: "error" }
                    );
                    localStorage.clear();
                    window.location.href = "/"; // Use full page reload to ensure all state is cleared
                }
            } catch (error) {
                console.log('Error validating query string:', error);
            }
        };

        validateQueryString(propertyIdFromQuery);
    }, [])

    // We'll fetch property-near-amenities from inside the effect below to avoid
    // creating a callback that changes identity on every render.

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const propertyIdFromQuery = params.get("id");

        if (propertyIdFromQuery && propertyIdFromQuery !== "0") {
            const normalizedId = String(propertyIdFromQuery);
            setQueryPropertyId(normalizedId);
            setPropertyId(normalizedId);
            setPropertyIdFilter(normalizedId);

        }
    }, [location.search]);

    const getDDLProperties = async () => {
        try {
            const result = await fetchAllProperties();
            if (!result) return;

            let properties = result.data || result;
            if (Array.isArray(properties) && properties.length > 0) {
                const ddlOptions = buildPropertyOptions(properties);
                setLstProperties(ddlOptions);
                setLstPropertiesFilter(
                    queryPropertyId && queryPropertyId !== "0"
                        ? ddlOptions.filter(
                            (item) => String(item.PropertyId) === String(queryPropertyId) || String(item.PropertyId) === "0"
                        )
                        : ddlOptions
                );
            }
        } catch (error) {
            console.log("Error fetching properties:", error);
        }
    };

    const fetchAllNearAmenities = async () => {
        try {
            const result = await GetAllNearbyAmenities();
            if (!result) return;

            let amenities = result.data || result;
            if (Array.isArray(amenities) && amenities.length > 0) {
                const mapped = amenities.map((amenity) => ({
                    AmenityName: amenity.TypeName,
                    AmenityId: amenity.TypeId,
                }));
                setLstAmenities(mapped);
            }
        } catch (error) {
            console.log("Error fetching amenities:", error);
        }
    };

    const fetchPropertyNearAmenities = async () => {
        try {
            const tokenStr = (() => {
                try { const t = localStorage.getItem('tcn'); return t ? JSON.parse(t) : null; } catch { return localStorage.getItem('tcn'); }
            })();
            const headers = { "Content-Type": "application/json" };
            if (tokenStr) headers["Authorization"] = `Bearer ${tokenStr}`;

            const response = await fetch(`${PropertyNearAmenities}GetPropertyNearAmenitiesByVendorId/${vendorid}`, {
                method: "POST",
                headers,
            });

            if (!response.ok) {
                const err = await response.text();
                throw new Error(err || `Request failed with status ${response.status}`);
            }

            const result = await response.json();
            const list = result?.data || result || [];
            const rows = Array.isArray(list) ? list : [];
            setLstPropertyNearAmenities(rows);
            setLstPropertyNearAmenitiesFilter(rows);
        } catch (error) {
            console.log("Error fetching property amenities:", error);
        }
    };

    useEffect(() => {


        getDDLProperties();
        fetchAllNearAmenities();
        fetchPropertyNearAmenities();
    }, [queryPropertyId]);

    const handleSelectProperty = (item) => {
        const value = item?.PropertyId ?? item?.value ?? item ?? "";
        setPropertyId(String(value));
    };

    const handleToggleAmenity = (amenity) => {
        const amenityId = String(amenity.AmenityId);
        const alreadySelected = selectedAmenitiesData.find((item) => String(item.AmenityId) === amenityId);

        if (alreadySelected) {
            setSelectedAmenitiesData((prev) => prev.filter((item) => String(item.AmenityId) !== amenityId));
            return;
        }

        setSelectedAmenitiesData((prev) => [
            ...prev,
            {
                AmenityId: amenityId,
                AmenityName: amenity.AmenityName,
                Distance: "",
                DistanceType: "Select",
            },
        ]);
    };

    const handleUpdateDistance = (amenityId, distance) => {
        setSelectedAmenitiesData((prev) =>
            prev.map((item) =>
                String(item.AmenityId) === String(amenityId)
                    ? { ...item, Distance: distance }
                    : item
            )
        );
    };

    const handleUpdateDistanceType = (amenityId, distanceType) => {
        setSelectedAmenitiesData((prev) =>
            prev.map((item) =>
                String(item.AmenityId) === String(amenityId)
                    ? { ...item, DistanceType: distanceType }
                    : item
            )
        );
    };

    const handleRemoveSelectedAmenity = (amenityId) => {
        setSelectedAmenitiesData((prev) => prev.filter((item) => String(item.AmenityId) !== String(amenityId)));
    };

    const handleSubmit = async (e) => {
        e?.preventDefault?.();

        if (!PropertyId || PropertyId === "0") {
            enqueueSnackbar("Please select a property", { variant: "warning" });
            return;
        }

        if (selectedAmenitiesData.length === 0) {
            enqueueSnackbar("Please select at least one amenity", { variant: "warning" });
            return;
        }

        const invalidItems = selectedAmenitiesData.filter(
            (item) => !item.Distance || !item.DistanceType || item.DistanceType === "Select"
        );

        if (invalidItems.length > 0) {
            enqueueSnackbar(
                `Please fill distance and distance type for all amenities. ${invalidItems.length} item(s) incomplete.`,
                { variant: "warning" }
            );
            return;
        }

        setIsLoading(true);
        try {
            const toSubmit = selectedAmenitiesData.filter((amenityData) => {
                const isDuplicate = lstPropertyNearAmenities.some(
                    (item) =>
                        String(item.PropertyId) === String(PropertyId) &&
                        String(item.MasterAmenityId) === String(amenityData.AmenityId)
                );

                if (isDuplicate) {
                    console.warn(`Amenity ${amenityData.AmenityName} already added to property`);
                }

                return !isDuplicate;
            });

            const duplicateCount = selectedAmenitiesData.length - toSubmit.length;

            if (toSubmit.length === 0) {
                if (duplicateCount > 0) {
                    enqueueSnackbar(`${duplicateCount} amenity(ies) already added to this property`, { variant: "info" });
                }
                return;
            }

            const payload = toSubmit.map((amenityData) => ({
                PropertyId: parseInt(PropertyId, 10),
                MasterAmenityId: parseInt(amenityData.AmenityId, 10),
                CreatedBy: parseInt(vendorid, 10),
                Distance: amenityData.Distance,
                DistanceType: amenityData.DistanceType,
            }));

            const headers = { "Content-Type": "application/json" };
            if (Token) {
                const tokenStr =
                    typeof Token === "string"
                        ? Token
                        : Token.accessToken || Token.token || JSON.stringify(Token);
                headers["Authorization"] = `Bearer ${tokenStr}`;
            }

            const response = await fetch(`${PropertyNearAmenities}InsertPropertyNearAmenities`, {
                method: "POST",
                headers,
                body: JSON.stringify(payload),
            });

            // Parse response and check backend apioutput structure
            const resultJson = await response.json();
            if (!resultJson || resultJson.isSuccess !== true) {
                const msg = resultJson?.Message || resultJson?.message || 'Failed to add amenities';
                throw new Error(msg);
            }

            if (!queryPropertyId || queryPropertyId === "0") {
                setPropertyId("0");
            }
            setSelectedAmenitiesData([]);
            setUploadSuccess(true);

            enqueueSnackbar(`${toSubmit.length} amenity(ies) added successfully`, { variant: "success" });

            if (duplicateCount > 0) {
                enqueueSnackbar(`${duplicateCount} amenity(ies) already added to this property`, { variant: "info" });
            }

            // Refresh list
            await fetchPropertyNearAmenities();
            setTimeout(() => setUploadSuccess(false), 1000);
        } catch (error) {
            console.error(error);
            enqueueSnackbar(error.message || "Failed to add amenities", { variant: "error" });
        } finally {
            setIsLoading(false);
        }
    };

    const handleDeleteAmenities = async (amenityId) => {
        try {
            const tokenStr = typeof Token === "string" ? Token : (Token?.accessToken || Token?.token || JSON.stringify(Token));
            const headers = { "Content-Type": "application/json" };
            if (tokenStr) {
                headers["Authorization"] = `Bearer ${tokenStr}`;
            }

            const response = await fetch(`${PropertyNearAmenities}DeletePropertyNearAmenities/${amenityId}`, {
                method: "POST",
                headers,
            });

            if (!response.ok) {
                const err = await response.text();
                throw new Error(err || `Request failed with status ${response.status}`);
            }

            enqueueSnackbar("Amenity deleted successfully", { variant: "success" });
            const updatedList = lstPropertyNearAmenities.filter((item) => String(item.Id) !== String(amenityId));
            setLstPropertyNearAmenities(updatedList);
            setLstPropertyNearAmenitiesFilter(updatedList);
        } catch (error) {
            console.log("Error deleting amenity:", error);
            enqueueSnackbar("Failed to delete amenity", { variant: "error" });
        }
    };

    useEffect(() => {
        if (PropertyIdFilter && PropertyIdFilter !== "0") {
            const filteredAmenities = lstPropertyNearAmenities.filter((item) => String(item.PropertyId) === String(PropertyIdFilter));
            setLstPropertyNearAmenitiesFilter(filteredAmenities);
        } else {
            setLstPropertyNearAmenitiesFilter(lstPropertyNearAmenities);
        }
    }, [PropertyIdFilter, lstPropertyNearAmenities]);

    return (
        <>
            <MetaComponent meta={metadata} />
            <div className="layout-wrap">
                <Header2 />
                <SidebarMenu />
                <div className="main-content">
                    <div className="main-content-inner">
                        <div className="button-show-hide show-mb">
                            <span className="body-1">Show Dashboard</span>
                        </div>

                        <div className="widget-box-2 mb-20">
                            <h5 className="title">Add Near Facilities</h5>
                            <div className="box grid-3 gap-30">
                                <fieldset className="box-fieldset">
                                    <label htmlFor="country">
                                        Property Id/Name:<span>*</span>
                                    </label>
                                    <DropdownProperties
                                        options={lstPropertiesFilter}
                                        setItem={handleSelectProperty}
                                        refItem={Propertyref}
                                        StateValue={PropertyId}
                                        disabledflag={!!queryPropertyId && queryPropertyId !== "0"}
                                    />
                                </fieldset>
                            </div>

                            <div className="box grid-12 gap-30">
                                <fieldset className="box-fieldset">
                                    <label htmlFor="amenities-label">
                                        Select Facilities:<span>*</span>
                                    </label>
                                    <div className="add-near-amenities-chip-list">
                                        {lstAmenities.length > 0 ? (
                                            lstAmenities.map((amenity) => {
                                                const isSelected = selectedAmenitiesData.some(
                                                    (item) => String(item.AmenityId) === String(amenity.AmenityId)
                                                );

                                                const savedEntry = lstPropertyNearAmenities.find((item) =>
                                                    String(item.MasterAmenityId) === String(amenity.AmenityId) &&
                                                    String(item.PropertyId) === String(PropertyId)
                                                );

                                                const isSaved = !!savedEntry;

                                                const handleChipClick = () => {
                                                    if (isSaved) {
                                                        // delete the existing saved amenity record (uses DB Id)
                                                        if (window.confirm("Are you sure you want to delete this amenity?")) {
                                                            handleDeleteAmenities(savedEntry.Id);
                                                        }
                                                        return;
                                                    }

                                                    handleToggleAmenity(amenity);
                                                };

                                                return (
                                                    <button
                                                        key={amenity.AmenityId}
                                                        type="button"
                                                        className={`add-near-amenities-chip ${isSaved || isSelected ? "is-active" : ""}`}
                                                        onClick={handleChipClick}
                                                        title={isSaved ? "Click to remove saved amenity" : "Click to add/remove amenity"}
                                                    >
                                                        {amenity.AmenityName}
                                                    </button>
                                                );
                                            })
                                        ) : (
                                            <p className="no-amenities">No amenities available</p>
                                        )}
                                    </div>
                                </fieldset>
                            </div>

                            {selectedAmenitiesData.length > 0 && (
                                <div className="box grid-12 gap-30 selected-amenities-list">
                                    <div className="amenities-list-container">
                                        <h6 className="list-title">Selected Amenities - Fill Distance & Type</h6>
                                        <div className="amenities-list">
                                            {selectedAmenitiesData.map((amenity, index) => (
                                                <div key={amenity.AmenityId} className="amenity-row">
                                                    <div className="amenity-info">
                                                        <span className="amenity-index">{index + 1}.</span>
                                                        <span className="amenity-name">{amenity.AmenityName}</span>
                                                    </div>
                                                    <div className="amenity-inputs">
                                                        <div className="input-group distance-input-group">
                                                            <input
                                                                type="text"
                                                                className="form-control amenity-distance-input"
                                                                placeholder="Enter distance"
                                                                value={amenity.Distance}
                                                                onChange={(e) => handleUpdateDistance(amenity.AmenityId, e.target.value)}
                                                                maxLength={5}
                                                                onKeyDown={handleKeyNumberwithDotPress}
                                                            />
                                                        </div>
                                                        <div className="input-group distance-type-group">
                                                            <select
                                                                className="form-control amenity-distance-type-select"
                                                                value={amenity.DistanceType}
                                                                onChange={(e) => handleUpdateDistanceType(amenity.AmenityId, e.target.value)}
                                                            >
                                                                <option value="Select">Select</option>
                                                                <option value="Km">Km</option>
                                                                <option value="Meters">Meters</option>
                                                            </select>
                                                        </div>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-remove-amenity"
                                                            onClick={() => handleRemoveSelectedAmenity(amenity.AmenityId)}
                                                            title="Remove this amenity"
                                                        >
                                                            ✕
                                                        </button>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="box-btn">
                            <button
                                className="tf-btn primary"
                                onClick={handleSubmit}
                                disabled={isLoading || !PropertyId || PropertyId === "0" || selectedAmenitiesData.length === 0}
                                style={{
                                    opacity: isLoading || !PropertyId || PropertyId === "0" || selectedAmenitiesData.length === 0 ? 0.6 : 1,
                                    cursor: isLoading || !PropertyId || PropertyId === "0" || selectedAmenitiesData.length === 0 ? "not-allowed" : "pointer",
                                }}
                            >
                                {isLoading && (
                                    <span style={{ marginRight: "8px", display: "inline-flex", alignItems: "center" }}>
                                        <ClipLoader size={16} color="currentColor" />
                                    </span>
                                )}
                                {isLoading ? "Processing..." : uploadSuccess ? "Added ✓" : "Add Amenities"}
                            </button>
                        </div>

                        {/* <div className="widget-box-2 wd-listing" style={{ marginTop: "30px" }}>
                            <h5 className="title">Filter Amenities</h5>
                            <div className="wrap-table">
                                <div className="box grid-3 gap-30">
                                    <fieldset className="box-fieldset">
                                        <DropdownProperties
                                            options={lstPropertiesFilter}
                                            setItem={setPropertyIdFilter}
                                            refItem={PropertyFilterref}
                                            StateValue={PropertyIdFilter}
                                            disabledflag={!!queryPropertyId && queryPropertyId !== "0"}
                                        />
                                    </fieldset>
                                </div>
                                <div className="table-responsive">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th style={{ width: "8%" }}>Sr No</th>
                                                <th>Property Id / Title</th>
                                                <th style={{ width: "5%" }}>Amenities Name</th>
                                                <th style={{ width: "5%" }}>Distance</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {lstPropertyNearAmenitiesFilter.slice((page - 1) * ItemsPerPage, page * ItemsPerPage).map((amenitiesItem, index) => (
                                                <tr className="file-delete" key={amenitiesItem.Id || index}>
                                                    <td style={{ width: "8%" }}>
                                                        <span style={{ marginLeft: "20px" }}>{(page - 1) * ItemsPerPage + index + 1}</span>
                                                    </td>
                                                    <td>
                                                        <div className="listing-box">
                                                            <div className="content">
                                                                <div className="title">
                                                                    <ul className="list-action">
                                                                        <li>
                                                                            <Link className="link">{amenitiesItem.PropertyGeneratedId}</Link>
                                                                        </li>
                                                                        <li>
                                                                            <Link className="link">{amenitiesItem.PropertyTitle}</Link>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <ul className="list-action">
                                                            <li>
                                                                <div className="widget-box-2" style={{ padding: "0px" }}>
                                                                    <div className="box-info-property">{amenitiesItem.AmenitiesName}</div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                    <td>
                                                        <ul className="list-action">
                                                            <li>
                                                                <div className="widget-box-2" style={{ padding: "0px" }}>
                                                                    <div className="box-info-property">
                                                                        {amenitiesItem.Distance} {amenitiesItem.DistanceType}
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                    <td>
                                                        <ul className="list-action">
                                                            <li>
                                                                <a
                                                                    className="btn btn-sm btn-danger"
                                                                    onClick={() => {
                                                                        if (window.confirm("Are you sure you want to delete this amenities?")) {
                                                                            handleDeleteAmenities(amenitiesItem.Id);
                                                                        }
                                                                    }}
                                                                >
                                                                    Delete
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                                <ul className="wd-navigation">
                                    <Pagination2
                                        itemLength={lstPropertyNearAmenitiesFilter.length}
                                        itemPerPage={ItemsPerPage}
                                        setPage={setPage}
                                    />
                                </ul>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="overlay-dashboard" />
            </div>
        </>
    );
}
